import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { closeMenu } from "./app";

let mm = gsap.matchMedia();
gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother, ScrollToPlugin);
ScrollTrigger.defaults({
  markers: false,
});
document.addEventListener("DOMContentLoaded", function(){
  console.log('edits made sunday')
})
let scroller;
scroller = ScrollSmoother.create({
  smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
  //effects: true, // looks for data-speed and data-lag attributes on elements
  //smoothTouch: 0.01,
});

// subscribe button in header
$("header nav button#subscribe").click(function () {
  // scroll to footer
  const footer = gsap.utils.selector("footer");
  console.log("footer", footer);
  gsap.to(scroller, { duration: 1, scrollTo: footer });

  // close menu "manually"
  document.querySelector("#main-nav").classList.add("-translate-y-full");
  document.querySelector("#main-nav").classList.remove("translate-y-0");
  document.querySelector("#overlay").classList.add("hidden");

  // focus on input
  $("footer form input").first().focus();
});

mm.add("(min-width: 1024px)", () => {
  console.log("animation.js");

  // BLOCK: splt screen text slider
  const splitScreenTextSlidesContent = gsap.utils.toArray(
    ".split-screen-text-slider .right:not(:first-child)"
  );
  const splitScreenTextSlidesHeadings = gsap.utils.toArray(
    ".split-screen-text-slider .left .heading"
  );
  if (
    splitScreenTextSlidesContent &&
    splitScreenTextSlidesContent.length > 0 &&
    splitScreenTextSlidesHeadings &&
    splitScreenTextSlidesHeadings.length > 0
  ) {
    gsap.set(splitScreenTextSlidesContent, { yPercent: 101 });
    const animation = gsap.to(splitScreenTextSlidesContent, {
      yPercent: 0,
      duration: 1,
      stagger: 1,
    });
    ScrollTrigger.create({
      trigger: ".split-screen-text-slider",
      start: "top top",
      end: "bottom bottom",
      pin: ".split-screen-text-slider .left",
      animation: animation,
      //snap: 1 / (splitScreenTextSlidesContent.length),
      scrub: true,
      onUpdate: (self) => {
        const idx = findClosestIndexToProgress(
          splitScreenTextSlidesHeadings,
          self.progress
        );
        //console.log("index:", idx);
        if (idx != null) {
          gsap.to(splitScreenTextSlidesHeadings, { opacity: 0.1 });
          gsap.to(splitScreenTextSlidesHeadings[idx], {
            opacity: 1,
          });
        }
      },
    });
    gsap.set(splitScreenTextSlidesHeadings, { opacity: 0.1 });
    gsap.set(splitScreenTextSlidesHeadings[0], { opacity: 1 });
  }

  const postListings = gsap.utils.toArray(".post-listing");
  if (postListings) {
    ScrollTrigger.create({
      trigger: ".post-listing-wrapper",
      start: "top top",
      end: "bottom bottom",
      pin: ".archive-title",
    });
  }

  // BLOCK: Team
  const teamSections = gsap.utils.toArray(".team-section");

  teamSections.forEach((item, i) => {
    const headshots = item.querySelectorAll(".people .person");
    const leftSide = item.querySelector(".left");

    ScrollTrigger.create({
      trigger: item,
      start: "top top",
      end: "bottom bottom",
      pin: leftSide,
      onUpdate: () => {
        console.log("updating teamsections scrolltrigger");
      },
    });
  });

    // Generics
    const splitPinLeft = gsap.utils.toArray(".split-pin-left");
    splitPinLeft.forEach((item, i) => {
      ScrollTrigger.create({
        trigger: item.querySelector('.right'),
        start: "top top",
        end: "bottom bottom",
        pin: item.querySelector('.left'),
      });
    });
  
    const splitPinRight = gsap.utils.toArray(".split-pin-right");
    splitPinRight.forEach((item, i) => {
      ScrollTrigger.create({
        trigger: item.querySelector('.left'),
        start: "top top",
        end: "bottom bottom",
        pin: item.querySelector('.right'),
      });
    });
  

  //POST: Page Pinning
  const postContent = gsap.utils.toArray(".post-content");
  postContent.forEach((item, i) => {
    ScrollTrigger.create({
      trigger: item,
      start: "top top",
      end: "bottom bottom",
      pin: ".left-side-post",
    });
  });

  // end of matchmedia
});

// this will convert a progress between 0 and 1 into the closest index using the length of an array
function findClosestIndexToProgress(arr, prog) {
  if (!prog || !arr) return null;
  if (prog > 1) return null;
  //console.log(`arr.length:${arr.length} \n progress: ${prog.toFixed(3)}`);

  const closest = Math.round(prog * arr.length) - 1;
  //console.log(`closest: ${closest}`);
  if (closest < 0) return 0;
  return closest >= 0 ? closest : 0;
}
